const Language = [
    { key: "estonian", value: "Settings.Language.Et" },
    { key: "english", value: "Settings.Language.En" },
    { key: "russian", value: "Settings.Language.Ru" },
    { key: "latvian", value: "Settings.Language.Lv" }
];

export {
    Language
}